import { CompositeNavigationProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import React, { useCallback, useContext } from "react";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { StoreAllFilesComponent } from "../AllFilesComponent";
import { onPressIntegrationFileType } from "../FilesScreenComponent";
import { StorecastShowFileContext } from "./StorecastShowFileContext";
import { StorecastShowFileParamList } from "./StorecastShowFileNavigator";

type Props = {
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Dashboard">,
    NativeStackNavigationProp<
      StorecastShowFileParamList,
      "StorecastShowFileScreen"
    >
  >;
};

export function StorecastShowFileAllFiles(props: Props) {
  const { openFile } = useContext(StorecastShowFileContext);
  const onPressIntegrationFile: onPressIntegrationFileType = useCallback(
    ({ id, title }) => {
      props.navigation.navigateDeprecated("EmaginWebview", {
        eMaginId: id,
        title,
      });
    },
    [props.navigation]
  );
  return (
    <StoreAllFilesComponent
      onPressFile={openFile}
      onPressIntegrationFile={onPressIntegrationFile}
      includeIntegrationFiles={false}
    />
  );
}
